import * as Yup from 'yup';

export const emailSchema = (required = true, existingSchema, fieldName = 'Email address') => {
	let schema = existingSchema ?? Yup.string();
	schema = schema.trim().lowercase().email();
	if (required) {
		schema = schema.required(`${fieldName} is required.`);
	}
	schema = schema.test('domain-length', `${fieldName} should be a valid email`, (value) => {
		if (!value) return !required;

		if (value.includes(' ')) return false;

		const parts = value.split('@');
		const [prefix, domain] = parts;

		if (!domain || !prefix || domain.length <= 2) return false;
		if (prefix.startsWith('.') || prefix.endsWith('.') || prefix.includes('..')) return false;
		if (domain.startsWith('.') || domain.endsWith('.') || domain.includes('..')) return false;

		const domainParts = domain.split('.');
		if (domainParts.length < 2) return false;

		if (domainParts.slice(-1)[0].length < 2) return false;

		return domainParts.every((part) => part.length >= 1);
	});
	return schema;
};

export const phoneSchema = (label = 'Phone number') =>
	Yup.string()
		.transform((value) => (value === '' ? undefined : value))
		.notRequired()
		.min(7, `${label} should be more than 7 characters`)
		.max(15, `${label} should be no more than 15 characters`);
